import React from 'react';
import moment from 'moment';

import { currencyToNumber, numberToDecimal } from '../../../utils/currency';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '../../../constants';

export const getValueOrDefault =
  (locale, def, isNumber) =>
  /* istanbul ignore next */ ({
    column: {
      colDef: { field }
    },
    data
  }) => {
    const value = data[field];

    if (isNumber) {
      if (value) {
        return parseInt(value, 10);
      }
      return 0;
    }

    if (value === 'Invalid date') return '-';

    return value || def || locale['common.notAvailable'];
  };

const format =
  (formatter) =>
  ({ locale, localeText, name, search }) =>
  ({ data, value }) => {
    const val = data && name ? data[name] : value;

    if (search) {
      return typeof val === 'number'
        ? Number(val.toFixed(2))
        : Number(value.replace(/[^0-9.]/g, ''));
    }

    if (val && val !== locale[localeText || 'common.grid.empty']) {
      return formatter(val);
    }
    return val;
  };

export const formatCurrency = (amount, isDebit) => {
  if (!amount && amount !== 0) return <div className="currency">-</div>;
  const formatDecimal = Number(amount).toFixed(2);
  const formatCommas = formatDecimal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return <div className="currency">{isDebit ? `(${formatCommas})` : formatCommas}</div>;
};

export const formatCurrencyForComparator = (val) =>
  isNaN(Number(val)) ? (val === '-' ? 0 : currencyToNumber(val)) : val;

export default {
  toDecimal: format((v) => numberToDecimal(v)),
  toDate: format((v) => moment(v).format(DATE_FORMAT)),
  toDateTime: format((v) => moment(v).format(DATE_TIME_FORMAT)),
  toInt: format((v) => parseInt(v, 10) || 0)
};
